import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['label', 'input', 'pendingFlashTemplate'];

  onEnter(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey)
      return;

    event.preventDefault();

    if (!this.isFocused()) return;
    this.selectFiles();
  }

  isFocused() {
    return this.labelTarget === document.activeElement;
  }

  selectFiles() {
    this.inputTarget.click();
  }

  submit() {
    this.showPendingFlash();
    this.element.requestSubmit();
  }

  showPendingFlash() {
    this.removePendingFlash();

    const flashes = document.getElementById('flashes');
    if (!flashes) return;

    const fragment = document.importNode(
      this.pendingFlashTemplateTarget.content,
      true,
    );
    this.pendingFlash = fragment.firstElementChild;
    flashes.prepend(fragment);
  }

  removePendingFlash() {
    this.pendingFlash?.remove();
    this.pendingFlash = null;
  }
}
